/**
 * Record of the pending feature-intro keys from the last `module/select`
 * response (`pendingFeatureIntros`).
 *
 * The modal flow in `show-feature-intro.tsx` consumes the list directly at
 * module entry; this store exists for INLINE intros — UI that a screen renders
 * itself while its key is still pending (e.g. the SINGLE_USER_NUDGE banner on
 * User Management). Screens read `isFeatureIntroPending(key)` at render time
 * and call `clearPendingFeatureIntro(key)` after a successful dismiss so the
 * UI hides immediately; the server row keeps it hidden on future logins.
 *
 * Backed by sessionStorage, not module state: deep links load the SPA fresh
 * without re-running module/select (only the client-side context switches),
 * so an in-memory copy would be empty after any full page load and inline
 * intros would silently vanish until the next module entry.
 */

const STORAGE_KEY = 'PendingFeatureIntros';

export const SINGLE_USER_NUDGE = 'SINGLE_USER_NUDGE';

function readKeys(): string[] {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function setPendingFeatureIntros(keys: string[] | null | undefined): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Array.isArray(keys) ? keys : []));
}

export function isFeatureIntroPending(key: string): boolean {
  return readKeys().includes(key);
}

export function clearPendingFeatureIntro(key: string): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(readKeys().filter((k) => k !== key)));
}
